





































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatNumber, formatPercent } from '@/lib/reportFormatters';

@Component({ name: 'CampaignReports' })
export default class CampaignReports extends GiganautVue {

  campaignHeaders = [
    { text: 'Campaign', value: 'campaignName' },
    { text: 'Sent', value: 'emailsSent', align: 'end' },
    { text: 'Delivered', value: 'delivered', align: 'end' },
    { text: 'Opened', value: 'opened', align: 'end' },
    { text: 'Clicked', value: 'clicked', align: 'end' },
    { text: 'Bounced', value: 'bounced', align: 'end' },
    { text: 'Open Rate', value: 'openRate', align: 'end' },
    { text: 'Click Rate', value: 'clickRate', align: 'end' },
  ];

  get campaignPerformance() { return ManagementReportsModule.campaignPerformance; }

  fmtNum(v: number) { return formatNumber(v); }
  fmtPct(v: number) { return formatPercent(v); }
}
